const { zipCodeRegexNumeric } = require('../helpers');

exports.countryDefinition = {
  country: 'Russia Federation',
  code: 'RU',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'Locality', width: 0.5 },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [['company'], ['address'], ['address2'], ['city'], ['zipCode']],
  formFormat: [['company'], ['address'], ['address2'], ['city'], ['zipCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(6)),
      error: 'Must be 6 characters, 123456'
    }
  ]
};
